// extracted by mini-css-extract-plugin
export var billingAddress = "_yd-g";
export var contactInfo = "_yd-d";
export var customerInfoContainer = "_yd-c";
export var customerInfoContainerMobile = "_yd-h";
export var customerInfoRow = "_yd-a";
export var customerInfoSection = "_yd-b";
export var fullWidthDividerMobile = "_yd-i";
export var imageContainer = "_yd-1";
export var paymentMethod = "_yd-e";
export var priceText = "_yd-6";
export var priceTextMobile = "_yd-7";
export var product = "_yd-0";
export var productImage = "_yd-2";
export var productInfo = "_yd-4";
export var productMobile = "_yd-9";
export var productTitle = "_yd-8";
export var quantityBadge = "_yd-3";
export var quantityText = "_yd-5";
export var shippingAddress = "_yd-f";